export const getDiffInHours = (start, end) => {
  const timeDifference = end.getTime() - start.getTime();
  return timeDifference / (1000 * 3600);
};

export function formatDate(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}
